module.exports = __webpack_public_path__ + "static/hosting-fbbb7e6b700a7f8857dc680df07c24f0.png";